import React from "react";

const NewCampaign = () => {
  return <div>NewCampaign</div>;
};

export default NewCampaign;
